import { CustomFilter } from "@/types/custom-filter";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Capitalize filter
 */
export const capitalizeFilter: CustomFilter = {
  capitalize(value: any): string {
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
};
